export default {
	name: 'topSellersSection',
	title: 'Top Sellers Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'services',
			title: 'Featured Services',
			type: 'array',
			of: [
				{
					type: 'reference',
					to: [{ type: 'service' }],
				},
			],
		},
	],
};
